import {
  usePublicationId,
  usePublicationStep,
} from '@contexts/PropertyListingPublications/components/shared';
import { useLastKnownPublicationStep } from '@contexts/PropertyListingPublications/gql/hooks';
import * as React from 'react';

export default function PublicationLocationTracker() {
  const publicationId = usePublicationId();
  const currentStep = usePublicationStep();

  const { update } = useLastKnownPublicationStep(publicationId);

  React.useEffect(() => {
    update(currentStep);
  }, []);

  return null;
}
